import { IErrorHandling, OnboardingFormFields } from '@Types/index';

export const AddressErrorMap = {
  INVALID_CITY: 4043,
  INVALID_COUNTRY: 4044,
  INVALID_STATE: 4045,
  INVALID_POSTAL: 4046,
  INVALID_LINE1: 4052,
  INVALID_LINE2: 4076,
  ADDRESS_PO_BOX: 4066,
  ADDRESS_NOT_DELIVERABLE: 40067,
  INVALID_LINE1_PO_BOX: 41197,
  BUSINESS_ADDRESS_AGENT: 61001,
};

export const AddressErrorsObjectMap = new Map<number, IErrorHandling>([
  [
    AddressErrorMap.BUSINESS_ADDRESS_AGENT,
    {
      errorCode: AddressErrorMap.BUSINESS_ADDRESS_AGENT,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.LINE1,
      callBack: () => {},
    },
  ],
  [
    AddressErrorMap.INVALID_LINE1_PO_BOX,
    {
      errorCode: AddressErrorMap.INVALID_LINE1_PO_BOX,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.LINE1,
      callBack: () => {},
    },
  ],
  [
    AddressErrorMap.INVALID_CITY,
    {
      errorCode: AddressErrorMap.INVALID_CITY,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.CITY,
      callBack: () => {},
    },
  ],
  [
    AddressErrorMap.INVALID_COUNTRY,
    {
      errorCode: AddressErrorMap.INVALID_COUNTRY,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.COUNTRY,
      callBack: () => {},
    },
  ],
  [
    AddressErrorMap.INVALID_STATE,
    {
      errorCode: AddressErrorMap.INVALID_STATE,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.STATE,
      callBack: () => {},
    },
  ],

  [
    AddressErrorMap.INVALID_POSTAL,
    {
      errorCode: AddressErrorMap.INVALID_POSTAL,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.ZIP,
      callBack: () => {},
    },
  ],

  [
    AddressErrorMap.INVALID_LINE1,
    {
      errorCode: AddressErrorMap.INVALID_LINE1,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.LINE1,
      callBack: () => {},
    },
  ],
  [
    AddressErrorMap.INVALID_LINE2,
    {
      errorCode: AddressErrorMap.INVALID_LINE2,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.APARTMENT,
      callBack: () => {},
    },
  ],

  [
    AddressErrorMap.ADDRESS_PO_BOX,
    {
      errorCode: AddressErrorMap.ADDRESS_PO_BOX,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.LINE1,
      callBack: () => {},
    },
  ],
  [
    AddressErrorMap.ADDRESS_NOT_DELIVERABLE,
    {
      errorCode: AddressErrorMap.ADDRESS_NOT_DELIVERABLE,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.LINE1,
      callBack: () => {},
    },
  ],
]);
